"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permissionEnumReverse = exports.permissionEnum = void 0;
const permissionEnum = {
  EXPERIMENT_CREATE: 1,
  EXPERIMENT_READ: 2,
  EXPERIMENT_UPDATE: 3,
  EXPERIMENT_DELETE: 4,
  EXPERIMENT_TERMINATE: 5,
  PUBLISH_DEVELOPMENT: 6,
  PUBLISH_ENGNEW: 7,
  PUBLISH_ENGPROD: 8,
  PUBLISH_PRODUCTION: 9,
  ALLOCATION_DEVELOPMENT: 10,
  ALLOCATION_ENGNEW: 11,
  ALLOCATION_ENGPROD: 12,
  ALLOCATION_PRODUCTION: 13,
  OVERRIDE_CREATE: 14,
  OVERRIDE_READ: 15,
  OVERRIDE_UPDATE: 16,
  OVERRIDE_DELETE: 17,
  NOTIFICATION_CREATE: 18,
  NOTIFICATION_READ: 19,
  NOTIFICATION_UPDATE: 20,
  NOTIFICATION_DELETE: 21,
  SUBSCRIPTION_CREATE: 22,
  SUBSCRIPTION_READ: 23,
  SUBSCRIPTION_UPDATE: 24,
  SUBSCRIPTION_DELETE: 25,
  USER_ADMINISTRATION: 26,
  SUBSCRIPTION_ADMINISTRATION: 27,
  EXPERIMENT_UPDATE_RUNNING: 28,
  EXPERIMENT_APPROVE_TECH: 29,
  TECH_UPDATE: 30,
  ACTIVATION_UPDATE: 31,
  EXPERIMENT_UPDATE_RUNNING_ALL: 32,
  EXPERIMENT_DELETE_TESTING: 33,
  EXPERIMENT_UPDATE_VERSION_RUNNING: 34,
  EXPERIMENT_REPUBLISH: 35,
  EXPERIMENT_CLONE: 36,
  FEATURE_FLAG: 37,
  EVALUATE_EXPERIMENT: 38,
  CONTENT_MAP_APPROVAL: 39,
  PUBLISH_CONTENT_MAP: 40,
  ARCHIVE_CONTENT_MAP: 41,
  CONTENT_MAP_CREATE: 42,
  AUDIENCE_CREATE: 43,
  EXPERIMENT_APPROVE_DS: 44,
  EXPERIMENT_TOGGLE_EXCLUSIVITY: 45,
  MANAGE_NETWORK_LOCKDOWN: 46
};
exports.permissionEnum = permissionEnum;
const permissionEnumReverse = {
  1: 'EXPERIMENT_CREATE',
  2: 'EXPERIMENT_READ',
  3: 'EXPERIMENT_UPDATE',
  4: 'EXPERIMENT_DELETE',
  5: 'EXPERIMENT_TERMINATE',
  6: 'PUBLISH_DEVELOPMENT',
  7: 'PUBLISH_ENGNEW',
  8: 'PUBLISH_ENGPROD',
  9: 'PUBLISH_PRODUCTION',
  10: 'ALLOCATION_DEVELOPMENT',
  11: 'ALLOCATION_ENGNEW',
  12: 'ALLOCATION_ENGPROD',
  13: 'ALLOCATION_PRODUCTION',
  14: 'OVERRIDE_CREATE',
  15: 'OVERRIDE_READ',
  16: 'OVERRIDE_UPDATE',
  17: 'OVERRIDE_DELETE',
  18: 'NOTIFICATION_CREATE',
  19: 'NOTIFICATION_READ',
  20: 'NOTIFICATION_UPDATE',
  21: 'NOTIFICATION_DELETE',
  22: 'SUBSCRIPTION_CREATE',
  23: 'SUBSCRIPTION_READ',
  24: 'SUBSCRIPTION_UPDATE',
  25: 'SUBSCRIPTION_DELETE',
  26: 'DISTILLERY_ADMINISTRATION',
  27: 'SUBSCRIPTION_ADMINISTRATION',
  28: 'EXPERIMENT_UPDATE_RUNNING',
  29: 'EXPERIMENT_APPROVE_TECH',
  30: 'TECH_UPDATE',
  31: 'ACTIVATION_UPDATE',
  32: 'EXPERIMENT_UPDATE_ALL_RUNNING',
  33: 'EXPERIMENT_DELETE_TESTING',
  34: 'EXPERIMENT_UPDATE_VERSION_RUNNING',
  35: 'EXPERIMENT_REPUBLISH',
  36: 'EXPERIMENT_CLONE',
  37: 'FEATURE_FLAG',
  38: 'EVALUATE_EXPERIMENT',
  39: 'CONTENT_MAP_APPROVAL',
  40: 'PUBLISH_CONTENT_MAP',
  41: 'ARCHIVE_CONTENT_MAP',
  42: 'CONTENT_MAP_CREATE',
  43: 'AUDIENCE_CREATE',
  44: 'EXPERIMENT_APPROVE_DS',
  45: 'EXPERIMENT_TOGGLE_EXCLUSIVITY',
  46: 'MANAGE_NETWORK_LOCKDOWN'
};
exports.permissionEnumReverse = permissionEnumReverse;